import Cookies, { CookieAttributes } from 'js-cookie';

export const setCookie = (name: string, value: string, options: CookieAttributes) =>
  Cookies.set(name, value, options);

export const getCookie = (cookieName: string) => Cookies.get(cookieName);

export const removeCookie = (cookieName: string) => Cookies.remove(cookieName);
